import React from "react";
import { observer } from "mobx-react";
import { PageLayout } from "../../../../common/layout";
import { useRootStore } from "../../../../store/contexts";
import { CollectiveManagementSocietyView } from "./CollectiveManagementSocietyView";
import { CollectiveManagementSocietyViewStore } from "../../store/CollectiveManagementSocietyViewStore";
import { useStore } from "../../../../hooks";

export const CollectiveManagementSocietyViewPage = observer(() => {
  const rootStore = useRootStore();
  const { router } = rootStore;

  const id = router.params?.id as string;
  const path = `/collectiveManagementSociety/view/${id}`;

  const store = useStore(
    path,
    () => {
      const s = new CollectiveManagementSocietyViewStore(rootStore);
      return s;
    },
    { id }
  );

  return (
    <div>
      <PageLayout
        navigationElements={{
          links: [],
          onNavigatedTo: (id) => {
            store.setCardState(id, true);
          },
        }}
      >
        <CollectiveManagementSocietyView
          collectiveManagementSocietyViewStore={store}
        />
      </PageLayout>
    </div>
  );
});
